import { useCallback, useEffect, useState } from "react"

import { getAvailableBillingDescriptorStatuses } from "../../../User/services"
import { descriptorStatuses } from "../../utils/Enrollment.util"

const useAvailableDescriptorStatuses = (enrollmentId) => {
  const [statuses, setStatuses] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchStatuses = useCallback(async () => {
    if (!enrollmentId) return

    setLoading(true)

    const res = await getAvailableBillingDescriptorStatuses(enrollmentId)

    if (res.ok && Array.isArray(res.data?.billing_descriptor_status)) {
      setStatuses(res.data.billing_descriptor_status)
    } else {
      setStatuses(descriptorStatuses)
    }

    setLoading(false)
  }, [enrollmentId])

  useEffect(() => {
    fetchStatuses()
  }, [fetchStatuses])

  return { statuses, loading }
}

export default useAvailableDescriptorStatuses
